exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-active-time-indicator {\n  margin-top: 3px;\n  margin-bottom: 5px;\n  width: 100%;\n}", ""]);

// exports
